import React from "react";
import userLogoH from "../../assets/user01.png";
import userLogoM from "../../assets/user02.png";
import { useSelector } from "react-redux";

const User = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div className="flex gap-3 items-center bg-white p-4 rounded-full dark:bg-gray-600 dark:text-gray-300">
      <img
        src={user && Number(user.gender) === 1 ? userLogoM : userLogoH}
        alt="user image"
        className="w-14 
        h-14 rounded-full"
      />
      <div>
        <h3 className="font-semibold text-2xl">{user && user.username}</h3>
        <p>{user && user.tag_rol}</p>
      </div>
    </div>
  );
};

export default User;
